import React , { useState , useEffect }from 'react';
import RelativeSearchBar from './RelativeSearchBar';
import webapi from '../../../api/webapi';
import RelativeSearchResult from './RelativeSearchResult';
import EmptyDiv from '../Footer/EmptyDIV';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';

const RelativeSearchBox = (props) => {
    
    const [bookGroups,setBookGroups] = useState(undefined)
    const [books,setBooks] = useState(undefined)
    const [chapters,setChapters] = useState(undefined)
    const [selectedBookGroup,setSelectedBookGroup] = useState('')
    const [selectedBook,setSelectedBook] = useState('')
    const [selectedChapter,setSelectedChapter] = useState('')
    const [beforeWordCount,setBeforeWordCount] = useState(0)
    const [afterWordCount,setAfterWordCount] = useState(0)
    const [loadingShow,setLoadingShow] = useState(false)

    const [bookGroupShowAll,] = useState(false)
    const [bookShowAll,] = useState(false)
    const [chapterShowAll,] = useState(false)

    const [nextWord1,setNextWord1] = useState('')
    const [nextWord2,setNextWord2] = useState('')
    const [nextWord3,setNextWord3] = useState('')

    const [word,setWord] = useState(undefined)

    const [prevWord1,setPrevWord1] = useState('')
    const [prevWord2,setPrevWord2] = useState('')
    const [prevWord3,setPrevWord3] = useState('')

    const [countStr,setCountStr] = useState('00')
    const [results,setResults] = useState('')

    useEffect(()=>{
        setLoadingShow(true)
        
        getBookGroups();
        
        setLoadingShow(false)
    },[props.lang]) 
    

    const getBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+props.lang)
            .then(res => {
                setBookGroups(res.data);
            
                if (res.data && res.data[0] && res.data[0].Code)
                {
                    setSelectedBookGroup(res.data[0].Code);
                    getBooks(res.data[0].Code);
                }
                else
                {
                    setSelectedBookGroup('')
                    setSelectedBook('')
                    setSelectedChapter('')
                }
        })
    }

    const getBooks = async BookGroupCode =>{
        setLoadingShow(true)
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+props.lang)
            .then(res => {
                setBooks(res.data);
        
                if (res.data && res.data[0] && res.data[0].Code){
                    if ((res.data.length===1)||(!bookShowAll)){
                        setSelectedBook(res.data[0].Code)
                        getChapters(res.data[0].Code)
                    }else{
                        setSelectedBook('All');
                        getChapters('All');
                    }
                }else{
                    setSelectedBook('')
                    setSelectedChapter('')
                }    
            })            
    }

    const getChapters = async BookCode =>{
        setLoadingShow(true)
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+props.lang)
            .then(res => {
                setChapters(res.data);

                if (res.data && res.data[0] && res.data[0].Code){
                    if (res.data.length===1 || !chapterShowAll){
                        setSelectedChapter(res.data[0].Code)
                    }else{
                        setSelectedChapter('All');
                    }                    
                }
                setLoadingShow(false)  
       })      
    }

    const onChangeBookGroupSelect = async event => {
        setLoadingShow(true)
        setSelectedBookGroup(event.target.value);
        getBooks(event.target.value);
    };

    const onChangeBookSelect = async event => {
        setLoadingShow(true)
        setSelectedBook(event.target.value);
        getChapters(event.target.value);
    };

    const onChangeChapterSelect = async event => {
        setSelectedChapter(event.target.value)
    };

    const onChange = (id,wordParam) => {
        //console.log(id,wordParam)
        if (id === 'prevWord3') setPrevWord3(wordParam)
        if (id === 'prevWord2') setPrevWord2(wordParam)
        if (id === 'prevWord1') setPrevWord1(wordParam)
        if (id === 'word') setWord(wordParam)
        if (id === 'nextWord1') setNextWord1(wordParam)
        if (id === 'nextWord2') setNextWord2(wordParam)
        if (id === 'nextWord3') setNextWord3(wordParam)
    }

    const onSearchButtonClick = async () =>{
        //setmodalshow(false});
        setLoadingShow(true);
        setResults('');
        if ( word ){
            setWord(word.replaceAll('#','%23')
                        .replaceAll('*','{Star}')
                        .replaceAll('/','{Slash}')
                        .replaceAll('<','%2C')
                        .replaceAll('>','%2E')
                        .replaceAll('\\','{BackSlash}')
                        .trim()
            )
        }
        else
        {
            setWord('');
        }

        //console.log('p3:',prevWord3);
        //console.log('p2:',prevWord2);
        //console.log('p1:',prevWord1);
        //console.log('w:',word);
        //console.log('n1:',nextWord1);
        //console.log('n2:',nextWord2);
        //console.log('n3:',nextWord3);
        //console.log('countstr:',countStr);
        //console.log('SelectedBookGroup:',selectedBookGroup);
        //console.log('SelectedBook:',selectedBook);
        //console.log('SelectedChapter:',selectedChapter);

        var bookGroupVar = selectedBookGroup
        var bookVar = selectedBook
        var chapterVar = selectedChapter
        var countStrVar = countStr
        var prevWord3Var = prevWord3
        var prevWord2Var = prevWord2
        var prevWord1Var = prevWord1
        var TranscriptionVar = word
        var nextWord1Var = nextWord1
        var nextWord2Var = nextWord2
        var nextWord3Var = nextWord3

        if (prevWord3Var==='') prevWord3Var='null';
        if (prevWord2Var==='') prevWord2Var='null';
        if (prevWord1Var==='') prevWord1Var='null';
        if (TranscriptionVar==='') TranscriptionVar='null';
        if (nextWord1Var==='') nextWord1Var='null';
        if (nextWord2Var==='') nextWord2Var='null';
        if (nextWord3Var==='') nextWord3Var='null';

        //console.log('prevnext/'+bookGroupVar+'/'+bookVar+'/'+chapterVar+'/'+countStrVar+'/'+prevWord3Var+'/'+prevWord2Var+'/'+prevWord1Var+'/'+TranscriptionVar+'/'+nextWord1Var+'/'+nextWord2Var+'/'+nextWord3Var);
        try {
            const responseResult = await webapi.get('prevnext/'+bookGroupVar+'/'+bookVar+'/'+chapterVar+'/'+countStrVar+'/'+prevWord3Var+'/'+prevWord2Var+'/'+prevWord1Var+'/'+TranscriptionVar+'/'+nextWord1Var+'/'+nextWord2Var+'/'+nextWord3Var)
                .then(
                    setResults(responseResult.data)
                )
        } catch (error){
            setLoadingShow(false);
        }
        
        //console.log(responseResult.data);

        setLoadingShow(false);
    }

    const onChangeAfterWords = event => {
        setAfterWordCount(event.target.value)
        setCountStr(beforeWordCount+afterWordCount);
        if (afterWordCount<1) setNextWord1('')
        if (afterWordCount<2) setNextWord2('')
        if (afterWordCount<3) setNextWord3('')
    }

    const onChangeBeforeWords = event => {
        setBeforeWordCount(event.target.value)
        
        setCountStr(beforeWordCount+afterWordCount);
        
        if (beforeWordCount<1) setPrevWord1('')
        if (beforeWordCount<2) setPrevWord2('')
        if (beforeWordCount<3) setPrevWord3('')
    }

    return (
        <div className="container-fluid" id="relative_search_form">
            <Loading loadingShow={loadingShow} />
            <div className="container">
                <form>
                    <div className="select_param_30">           
                        <label>
                            {props.pageData.length!==0 && props.pageData[0].F20401!== undefined?props.pageData[0].F20401:20401/*نوع متن*/}
                        </label>
                        <select onChange={onChangeBookGroupSelect} className="">
                            {/* <option value={"All"}>همه</option> */}
                            {   bookGroups != null 
                                ?
                                (   
                                    bookGroups.map((bookGroup) =>{
                                        return  (
                                            <option key={bookGroup.Code} value={bookGroup.Code}>{bookGroup.Title}</option> 
                                        )
                                    })
                                )
                                :
                                <option key="-1">-</option>       
                            }
                        </select>
                    </div>
                    <div className="select_param_30">           
                        { 
                            (selectedBookGroup==="2")
                            ?
                            <label>{props.pageData.length!==0 && props.pageData[0].F20404!== undefined?props.pageData[0].F20404:20404/*نوع کتیبه*/}</label>
                            :
                            <label>{props.pageData.length!==0 && props.pageData[0].F20402!== undefined?props.pageData[0].F20402:20402/*نام متن*/}</label>
                        }
                        <select onChange={onChangeBookSelect} className="">
                            <option value={"All"}>{props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>
                            {   books != null 
                                ?
                                (   
                                    books.map((book) =>{
                                        return  (
                                            <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                        )
                                    })
                                )
                                :
                                <option key="-1">-</option>       
                            }
                        </select>
                    </div>
                    <div className="select_param_30">           
                        { 
                            (selectedBookGroup==="2")
                            ?
                            <label>{props.pageData.length!==0 && props.pageData[0].F20405!== undefined?props.pageData[0].F20405:20405/*نام کتیبه*/}</label>
                            :
                            <label>{props.pageData.length!==0 && props.pageData[0].F20403!== undefined?props.pageData[0].F20403:20403/*شماره فصل*/}</label>
                        }
                        <select onChange={onChangeChapterSelect}  className="">
                        {/* <option value={"All"}>همه</option> */}
                        {   chapters != null 
                            ?
                            (   chapters.map((chapter,i) =>{
                                    return  (
                                        (chapters.length>1 && i===0)
                                                ?
                                                (
                                                    <>
                                                    <option key={ chapter.Code + 'All' + i } value="All" select="true">{props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>
                                                    <option key={ chapter.Code + i } value={chapter.Code}>{chapter.Title}</option> 
                                                    </>
                                                )
                                                :
                                                (
                                                    <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                )
                                    )
                                })
                            )
                            :
                            <option key="-1">-</option>       
                        }
                        </select>
                    </div>
                    <br />
                    <div className="fullwidth_div">
                        <br />
                        <div className="select_param_30"  style={{float:'right'}}>
                            <div className="dropdown">
                                <span>
                                    {props.pageData.length!==0 && props.pageData[0].F20410!== undefined?props.pageData[0].F20410:20410/*تعداد کلمات پسین */}
                                </span>
                                <select className="btn dropdown-toggle" id="search_book" onChange={onChangeAfterWords}>
                                    <option key="0" value="0">0</option>
                                    <option key="1" value="1">1</option>
                                    <option key="2" value="2">2</option> 
                                    <option key="3" value="3">3</option>      
                                </select>
                            </div> 
                            {
                                parseInt(afterWordCount)>0
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="nextWord1"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20411!== undefined?props.pageData[0].F20411:20411/*"کلمه اول پسین"*/}
                                    ShowInClass={"Phonetic"}
                                    //ref={instance => { childnextword1 = instance; }}
                                />
                                :
                                null
                            }
                            {
                                parseInt(afterWordCount)>1
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="nextWord2"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20412!== undefined?props.pageData[0].F20412:20412/*"کلمه دوم پسین"*/}
                                    ShowInClass={"Phonetic"}
                                    //ref={instance => { childnextword2 = instance; }}
                                />
                                :
                                null
                            }
                            {
                                parseInt(afterWordCount)>2
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="nextWord3"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20413!== undefined?props.pageData[0].F20413:20413/*"کلمه سوم پسین"*/}
                                    ShowInClass={"Phonetic"}
                                    //ref={instance => { childnextword2 = instance; }}
                                />
                                :
                                null
                            }
                        </div>
                        
                        <div className="select_param_30" style={{float:'right'}}>
                            <RelativeSearchBar 
                                className="" 
                                id="word"
                                onChange={onChange} 
                                PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20406!== undefined?props.pageData[0].F20406:20406/*"کلمه اصلی جستجو"*/}
                                ShowInClass={"Phonetic"}
                                //ref={childword} 
                                //ref={instance => { childword = instance; }}
                            />
                        </div>

                        <div className="select_param_30" style={{float:'right'}}>
                            <div className="dropdown">
                                <span>
                                    {props.pageData.length!==0 && props.pageData[0].F20420!== undefined?props.pageData[0].F20420:20420/*تعداد کلمات پیشین*/}
                                </span>
                                <select className="btn dropdown-toggle" id="search_book" onChange={onChangeBeforeWords}>
                                    <option key="0" value="0">0</option>
                                    <option key="1" value="1">1</option>
                                    <option key="2" value="2">2</option> 
                                    <option key="3" value="3">3</option>      
                                </select>
                            </div>
                            {
                                parseInt(beforeWordCount)>0
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="prevWord1"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20421!== undefined?props.pageData[0].F20421:20421/*"کلمه اول پیشین"*/}
                                    ShowInClass={"Phonetic"}
                                />
                                :
                                null
                            }
                            {
                                parseInt(beforeWordCount)>1
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="prevWord2"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20422!== undefined?props.pageData[0].F20422:20422/*"کلمه دوم پیشین"*/}
                                    ShowInClass={"Phonetic"}
                                /> 
                                :
                                null
                            }
                            {
                                parseInt(beforeWordCount)>2
                                ?
                                <RelativeSearchBar 
                                    className="select_param" 
                                    id="prevWord3"
                                    onChange={onChange} 
                                    PlaceHolder={props.pageData.length!==0 && props.pageData[0].F20423!== undefined?props.pageData[0].F20423:20423/*"کلمه سوم پیشین"*/}
                                    ShowInClass={"Phonetic"}
                                />
                                :
                                null
                            }
                        </div>
                        <br />
                    </div>
                    <div className="fullwidth_div">
                        <input type="button" className="submit_button" onClick={onSearchButtonClick} value={props.pageData.length!==0 && props.pageData[0].F29901!== undefined?props.pageData[0].F29901:29901/*"جستجو"*/} />
                    </div>
                </form>
                <br />
                {
                    (
                        (results && results.length>0)
                    )
                    ?
                        <RelativeSearchResult   results={results}
                                                pageData={props.pageData}
                        />
                    :
                    <EmptyDiv /> 
                }
                <br />
            </div>
        </div>
    )
}

export default RelativeSearchBox;